import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import offerImg1 from '../Img/Main_Img_Slider1.jpg'
import offerImg2 from '../Img/oofer_home-img2.jpg'
import offerImg3 from '../Img/oofer_home-img3.jpg'
import offerImg4 from '../Img/Pdf-img.png'
import offerImg5 from '../Img/oofer_home-img5.jpg'
import offerImg6 from '../Img/oofer_home-img6.jpg'
import offerImg7 from '../Img/oofer_home-img7.jpg.png'
import offerImg8 from '../Img/oofer_home-img8.png'
import { title } from 'framer-motion/client';

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const ArticleAwardSection = () => {
  const navigate = useNavigate();

  const awardData = [
    {
      id: 1,
      img: offerImg1,
      title: 'Original Research Article',
      description:
        'A first-hand scientific study presenting new data, methods, and results, offering fresh insights to advance knowledge in a specific field.',
      targetId: '/current-issues#original-research-article'
    },
    {
      id: 2,
      img: offerImg2,
      title: 'Review Article',
      targetId:'/review-article',
      description:
        'A comprehensive summary of existing research, offering expert insights, identifying trends, and highlighting gaps to guide future studies.',
    },
    {
      id: 3,
      img: offerImg3,
      title: 'Clinical Study',
      targetId:'/clinical-study',
      description:
        'A research study conducted with human volunteers to evaluate the safety, effectiveness, and outcomes of medical treatments, drugs, or interventions.',
    },
    {
      id: 4,
      img: offerImg4,
      title: 'Essential for Medical Writing',
      targetId:'/essential-for-medical-writing',
      description:
        'Where science meets clarity, empowering your medical content with precision and purpose.',
    },
    {
      id: 5,
      img: offerImg5,
      title: 'Case Study',
      targetId:'/current-issues#case-study',
      description:
        'An in-depth analysis of a real-life situation, event, or individual, used to explore causes, outcomes, and lessons learned—commonly applied in clinical, business, and educational research.',
    },
    {
      id: 6,
      img: offerImg6,
      title: 'Short Communication',
      targetId:'/current-issues#short-communication',
      description:
        'A brief report that shares new, preliminary, or innovative findings—faster to publish and more concise than a full research article.',
    },
    {
      id: 7,
      img: offerImg7,
      title: 'Book Chapter',
      targetId:'/current-issues#book-chapter',
      description:
        'An individual section of a book that explores a specific topic in-depth, often written by experts as part of a larger academic or scientific volume.',
    },
    {
      id: 8,
      img: offerImg8,
      targetId:"/international-expert-opinion",
      title: 'International Expert Opinion',
      description: 'A special feature showcasing concise insights and expert opinions from leading global authorities on key topics in pharmaceutical and medical science.'
    }
  ];


  return (
    <motion.div
      className="article-section-pm"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={containerVariants}
    >
      <motion.h2 className="article-heading-pm" variants={itemVariants}>
        <span className='impact-word-highlight'>IMPACT</span> OFFERS TO PUBLISH
      </motion.h2>
      <motion.div className="article-cards-pm" variants={containerVariants}>
        {awardData.map((item) => (
          <motion.div className="article-card-pm" key={item.id} variants={itemVariants}>
            <img src={item.img} alt={item.title} />
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            <button
              onMouseMove={(e) => {
                const button = e.currentTarget;
                const rect = button.getBoundingClientRect();
                button.style.setProperty('--x', `${e.clientX - rect.left}px`);
                button.style.setProperty('--y', `${e.clientY - rect.top}px`);
              }}
              onClick={() => {
                window.location.href = item.targetId;
              }}
            >
              <span>Read More</span>
            </button>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default ArticleAwardSection;